import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import DesktopHeader from './views/DesktopHeader';
import MobileHeader from './views/MobileHeader';
import { useListingHeaderLogic } from './hooks/useListingHeaderLogic';
import { useNavigationLogic } from '../navigation/hooks/useNavigationLogic';

const EditHeader: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const logic = useListingHeaderLogic();
  const { handleGroupClick } = useNavigationLogic();

  if (logic.isNavigatingAway) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
      }}
    >
      {isMobile ? (
        <MobileHeader logic={logic} handleGroupClick={handleGroupClick} />
      ) : (
        <DesktopHeader logic={logic} handleGroupClick={handleGroupClick} />
      )}
    </Box>
  );
};

export default EditHeader;
